import React, { useEffect, useState } from 'react'
import { stuacademicyearlist, stuclasslist, studivisionlist } from '../../../services/master';
import { academylist, createfeeposting, listfeeposting, listfeestructure } from '../../../services/admin';
import Select from "react-select";
import { studentfilter } from '../../../services/student';
import moment from 'moment';
import { toast } from 'react-toastify';
import { AgGridReact } from 'ag-grid-react';
import { Modal } from 'react-bootstrap';

export const FeePosting = () => {
    const [ayear, setAYear] = useState("");
    const [alist, setAList] = useState([]);

    const [clist, setCList] = useState([]);
    const [stucls, setStuCls] = useState("");

    const [dlist, setDList] = useState([]);
    const [stusec, setStuSec] = useState("");

    const [aclist, setACList] = useState([]);
    const [acaid, setAcaID] = useState("");

    const [stulist, setStuList] = useState([]);
    const [slist, setSList] = useState([]);
    const [stuid, setStuId] = useState([]);

    const [duedate, setDueDate] = useState("");


    const [feelist, setFeeList] = useState([]);
    const [feeid, setFeeID] = useState("");
    const [filterProduct, setFilterProduct] = useState([]);

    function listyear(aid) {
        setAList([]);
        setAYear("");
        const temp = new FormData();
        if (localStorage.getItem("Role") === "1" && aid !== "") {
            temp.append("academy_id", aid.value);
        }
        stuacademicyearlist(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].aca_year,
                        });
                    }
                    setAList(arr);
                }
            }
        });
        listfeeposting(temp).then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    const sdata = res.data.map(item => ({
                        ...item,
                        due_date: moment(item.due_date).format("DD-MM-YYYY")
                    }));
                    setFilterProduct(sdata);
                }
            }
        })

    }
    useEffect(() => {
        setDueDate(moment(new Date()).format("YYYY-MM-DD"));

        stuclasslist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].class_name,
                        });
                    }
                    setCList(arr);
                }
            }
        });

        studivisionlist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.length > 0) {
                    for (let i = 0; i < res.data.length; i++) {
                        arr.push({
                            value: res.data[i].id,
                            label: res.data[i].name,
                        });
                    }
                    setDList(arr);
                }
            }
        });

        academylist().then((res) => {
            if (res.status === true) {
                let arr = [];
                if (res.data.details.length > 0) {
                    for (let i = 0; i < res.data.details.length; i++) {
                        arr.push({
                            value: res.data.details[i].id,
                            label:
                                res.data.details[i].name + " - " + res.data.details[i].code,
                        });
                    }
                    setACList(arr);
                }
            }
        });


        if (localStorage.getItem("AAcademy") != null) {
            academylist().then((res) => {
                if (res.status === true) {
                    let arr = [];
                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                                arr.push({
                                    value: res.data.details[i].id,
                                    label:
                                        res.data.details[i].name + " - " + res.data.details[i].code,
                                });
                            }
                            if (arr.length > 0) {
                                setAcaID(arr[0]);
                                listyear(arr[0]);
                                setAYear(localStorage.getItem("AYear"));
                            }
                        }

                    }
                }
            });
        } else {
            listyear("");
        }
    }, []);

    function handleAcademy(e) {
        if (e !== null) {
            setAcaID(e);
            listyear(e);
            filterstu(e, ayear, stucls, stusec);
        } else {
            setAcaID("");
            listyear("");
            filterstu("", ayear, stucls, stusec);
        }
    }

    function handleClass(e) {
        if (e !== null) {
            setStuCls(e);
            filterstu(acaid, ayear, e, stusec);
        } else {
            setStuCls("");
            filterstu(acaid, ayear, "", stusec);
        }
    }

    function handleSec(e) {
        if (e !== null) {
            setStuSec(e);
            filterstu(acaid, ayear, stucls, e);
        } else {
            setStuSec("");
            filterstu(acaid, ayear, stucls, "");
        }
    }

    function handleStu(e) {
        if (e !== null) {
            setStuId(e);
        } else {
            setStuId([]);
        }
    }
    function filterstu(aca, yr, cl, se) {
        setStuList([]);
        setSList([]);
        setStuId([]);
        setFeeID("");
        if (yr !== "" && cl !== "" && se !== "") {
            const temp = new FormData();
            temp.append("year", yr);
            temp.append("class", cl ? cl.value : "");
            temp.append("section", se ? se.value : "");
            
            if (localStorage.getItem("Role") === "1" && aca !== "") {
                temp.append("academy", aca.value);
            }
            studentfilter(temp).then((res) => {
                if (res.status === true) {
                    setSList(res.data.details);
                    let arr = [];

                    if (res.data.details.length > 0) {
                        for (let i = 0; i < res.data.details.length; i++) {
                            arr.push({
                                value: res.data.details[i].id,
                                label: res.data.details[i].username + " - " + res.data.details[i].student_name,
                            });
                        }
                    }
                    setStuList(arr);
                }
            });

            const temp1 = new FormData();
            if (localStorage.getItem("Role") === "1" && aca !== "") {
                temp1.append("academy_id", aca.value);
            }
            temp1.append("academic_year", yr);
            temp1.append("class", cl ? cl.value : "");
            temp1.append("section", se ? se.value : "");
            temp1.append("feetype", "");

            listfeestructure(temp1).then((res) => {
                if (res.status === true) {
                    setFeeList(res.data);
                }
            });
        }


    }

    const [errormsg, setErrMsg] = useState("");

    function handleSave(e) {
        e.preventDefault();
        setErrMsg("");
        if (stucls !== "") {
            if (stusec !== "") {
                if (stulist.length > 0) {
                    if (feeid !== "") {
                        const temp = new FormData();
                        if (localStorage.getItem("Role") === "1" && acaid !== "") {
                            temp.append("academy_id", acaid.value);
                        }
                        temp.append("structure_id", feeid);
                        temp.append("class_id", stucls.value);
                        temp.append("section_id", stusec.value);
                        temp.append("year_id", ayear);
                        temp.append("due_date", duedate);
                        temp.append("count", stuid.length);
                        for (let i = 0; i < stuid.length; i++) {
                                temp.append("student_id_" + [i + 1], stuid[i].value);
                        }
                        createfeeposting(temp).then((res) => {
                            if (res.status === true) {
                                setShow(false);
                                listyear(acaid);
                                toast.success(res.message);
                            } else {
                                toast.error(res.message);
                            }
                        });
                    } else {
                        setErrMsg("Please Select Fee Structure");
                    }
                } else {
                    setErrMsg("There is no student");
                }
            } else {
                setErrMsg("Please Select Section");
            }
        } else {
            setErrMsg("Please Select Class");
        }

    }

    const columnDefs = [

        {
            headerName: "Fee Type",
            field: "fee_type",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Academic Year",
            field: "aca_year",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Class",
            field: "class_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Section",
            field: "section_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Due Date",
            field: "due_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },

    ];
    const [show, setShow] = useState(false);
    function handleShow() {
        setErrMsg("");
        setStuCls("");
        setStuSec("");setStuId([]);
        setFeeID("");
        setFeeList([]);
        setDueDate(moment().format("YYYY-MM-DD"));

        setShow(true);
    }
    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Fee Structure</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Fee Module</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Fee Structure
                    </li>
                </ol>
            </div>
            <div className="content-body">
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h2 className="main-content-title tx-24 mg-b-5">
                                Fee Posting
                            </h2>
                        </div>
                        <div className="card-body">
                            <div className='text-right'>
                                <a className='btn btn-success' onClick={handleShow}>Add Fee Posting</a>
                            </div>
                            <div className="ag-theme-alpine ag-style mt-2">
                                <AgGridReact
                                    columnDefs={columnDefs}
                                    rowData={filterProduct}
                                    pagination="true"
                                    paginationPageSize="10"
                                    sortingOrder={["asc", "desc"]}
                                    suppressDragLeaveHidesColumns={true}
                                />
                            </div>
                            <Modal show={show} size='lg' onHide={() => setShow(false)}>
                                <Modal.Header>
                                    <Modal.Title>Add Fee Posting</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="row">
                                        {localStorage.getItem("Role") === "1" && (
                                            <div className="col-xl-4 col-sm-6">
                                                <div className="mb-3">
                                                    <label className="form-label">
                                                        Select Academy{" "}
                                                        <span className="text-danger"> *</span>
                                                    </label>
                                                    <Select
                                                        className="default-select"
                                                        placeholder="Select Academy"
                                                        value={acaid}
                                                        options={aclist}
                                                        onChange={handleAcademy}
                                                        isSearchable={true}
                                                        isClearable
                                                        hidden
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-6">
                                                <label className="form-label">
                                                    Academic Year<span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select form-control wide"
                                                    onChange={(e) => { setAYear(e.target.value); setStuList([]); }}
                                                    onBlur={(e) =>
                                                        filterstu(acaid, e.target.value, stucls, stusec)
                                                    }
                                                    value={ayear}
                                                >
                                                    <option value="" disabled>
                                                        Select Academic Year
                                                    </option>
                                                    {alist.map((item) => (
                                                        <option value={item.value} key={item.value}>
                                                            {item.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-6">
                                                <label className="form-label">
                                                    Class<span className="text-danger"> *</span>
                                                </label>
                                                <Select
                                                    // isMulti
                                                    options={clist}
                                                    value={stucls}
                                                    onChange={handleClass}
                                                    classNamePrefix="select"
                                                    placeholder="Select Class"
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />
                                            </div>
                                        </div>

                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-6">
                                                <label className="form-label">
                                                    Section
                                                    <span className="text-danger"> *</span>
                                                </label>
                                                <Select
                                                    // isMulti
                                                    options={dlist}
                                                    value={stusec}
                                                    onChange={handleSec}
                                                    classNamePrefix="select"
                                                    placeholder="Select Section"
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />
                                            </div>
                                        </div>

                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-6">
                                                <label className="form-label">
                                                    Student Name
                                                    {/* <span className="text-danger"> *</span> */}
                                                </label>
                                                <Select
                                                    isMulti
                                                    className="default-select"
                                                    placeholder="Select Student"
                                                    value={stuid}
                                                    options={stulist}
                                                    onChange={handleStu}
                                                    isSearchable={true}
                                                    isClearable
                                                    hidden
                                                />
                                            </div>
                                        </div>

                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-6">
                                                <label className="form-label">
                                                    Fee Structure<span className="text-danger"> *</span>
                                                </label>
                                                <select
                                                    className="default-select form-control wide"
                                                    value={feeid}
                                                    onChange={(e) => setFeeID(e.target.value)}
                                                >
                                                    <option value="" disabled>
                                                        Select Fee Structure
                                                    </option>
                                                    {feelist.map((item) => (
                                                        <option value={item.id} key={item.id}>
                                                            {item.fee_type} - {item.amount}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>

                                        <div className="col-xl-4 col-sm-6">
                                            <div className="mb-6">
                                                <label className="form-label">
                                                    Due Date<span className="text-danger"> *</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    placeholder="Enter Due Date"
                                                    value={duedate}
                                                    onChange={(e) => setDueDate(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {errormsg !== "" && (
                                        <span className="text-danger">{errormsg}</span>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>

                                    <div className="res text-right">
                                        <a className="btn btn-danger me-2" onClick={() => setShow(false)}>
                                            Close
                                        </a>
                                        <a className="btn btn-success" onClick={handleSave}>
                                            Submit Posting
                                        </a>
                                    </div>
                                </Modal.Footer>
                            </Modal>

                        </div>
                    </div>



                </div>
            </div>
        </div>
    )
}
